// Simple flag marks used for the language switch: UK = English, UAE = Arabic.
export const FlagUK = ({ className = "h-4 w-6" }) => (
  <svg viewBox="0 0 60 30" className={className} aria-hidden="true">
    <rect width="60" height="30" fill="#012169" />
    <path d="M0,0 60,30 M60,0 0,30" stroke="#fff" strokeWidth="6" />
    <path d="M0,0 60,30 M60,0 0,30" stroke="#C8102E" strokeWidth="3" />
    <path d="M30,0 v30 M0,15 h60" stroke="#fff" strokeWidth="10" />
    <path d="M30,0 v30 M0,15 h60" stroke="#C8102E" strokeWidth="6" />
  </svg>
);

export const FlagUAE = ({ className = "h-4 w-6" }) => (
  <svg viewBox="0 0 60 30" className={className} aria-hidden="true">
    <rect width="60" height="10" fill="#00732F" />
    <rect y="10" width="60" height="10" fill="#fff" />
    <rect y="20" width="60" height="10" fill="#000" />
    <rect width="15" height="30" fill="#FF0000" />
  </svg>
);
